import { z } from 'zod';
import { AttendanceStatus } from '../enums.js';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString, optionalEmail } from './common.js';
export const createEmployeeSchema = z.object({
    firstName: z.string().trim().min(1, 'Prénom requis').max(100),
    lastName: z.string().trim().min(1, 'Nom requis').max(100),
    phone: optionalString(30),
    email: optionalEmail(),
    position: z.string().trim().min(1, 'Fonction requise').max(100),
    hireDate: z.coerce.date().optional(),
    isActive: z.boolean().default(true),
    // Marque l'employé comme mécanicien (crée l'enregistrement Mechanic associé).
    isMechanic: z.boolean().default(false),
    specialty: optionalString(120),
});
export const updateEmployeeSchema = createEmployeeSchema.partial();
export const createScheduleSchema = z.object({
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date(),
    note: optionalString(255),
});
export const createAttendanceSchema = z.object({
    date: z.coerce.date(),
    status: z.nativeEnum(AttendanceStatus).default(AttendanceStatus.PRESENT),
    checkIn: z.coerce.date().optional(),
    checkOut: z.coerce.date().optional(),
    note: optionalString(255),
});
export const employeesQuerySchema = paginationQuerySchema.extend({
    active: z.union([z.boolean(), z.enum(['true', 'false'])]).optional().transform((v) => (v === undefined ? undefined : v === true || v === 'true')),
});
//# sourceMappingURL=employee.js.map